import React, {useState, useContext} from 'react';
import {db} from '../firebase';
import {UsuarioContext} from '../Context/UsuarioProvider';
import {LibrosContext} from '../Context/LibrosProvider';

const AgregarLibros = () => {

    const [titulo, setTitulo] = useState('')
    const [paginas, setPaginas] = useState('')

    const {usuario} = useContext(UsuarioContext)
    const {fetchLibros} = useContext(LibrosContext)

    const agregarLibro = e => {
        e.preventDefault()
        if(!titulo.trim() || !paginas.trim()){
            console.log('campo vacio')
            return
        }

        db.collection('libros').add({
            autor: db.collection('usuarios').doc(usuario.email),
            paginas: paginas,
            titulo: titulo,
            uid: usuario.uid
        })
        .then(res => {
            console.log(res)
            fetchLibros()
        })
        .catch(error => console.log(error))     
        
        setTitulo('')
        setPaginas('')
    }

    return (
        <div className='my-5'>
            <h1>Agregar libros</h1>
            <form onSubmit={agregarLibro}>
                <input 
                    type="text" 
                    placeholder='Ingrese título' 
                    className='form-control mb-2' 
                    onChange={e => setTitulo(e.target.value)}
                    value={titulo}
                />
                <input 
                    type="text" 
                    placeholder='Ingrese páginas' 
                    className='form-control mb-2' 
                    onChange={e => setPaginas(e.target.value)}
                    value={paginas}
                />
                <button
                    className='btn btn-dark'
                    type='submit'
                >
                    Agregar
                </button>
            </form>
        </div>
    )
}

export default AgregarLibros
